import type { CookieOptions } from '@packages/utils/types/cookies.ts'

const getCookie = (name: string): string | undefined => {
  if (!import.meta.client) {
    return
  }

  return document.cookie
    .split(';')
    .map(cookie => cookie.trim().split('='))
    .find(cookie => cookie[0] === name)?.[1]
}

const cookieStrToObj = (cookieString: string): Record<string, string> => cookieString
  .split(';')
  .reduce((cookieObj: Record<string, string>, cookie) => {
    const [key, value] = decodeURIComponent(cookie).trim().split('=')

    return {
      ...cookieObj,
      [key]: value,
    }
  }, {})

const trySetCookie = (
  name: string,
  value: string,
  { maxAgeSeconds, domain, path = '/', sameSite = 'Lax' }: CookieOptions = {}
): boolean => {
  if (!import.meta.client) {
    return false
  }

  document.cookie = [
    `${name}=${value}`,
    `Path=${path}`,
    `SameSite=${sameSite}`,
    ...(domain ? [`Domain=${domain}`] : []),
    ...(maxAgeSeconds === undefined ? [] : [`Max-Age=${maxAgeSeconds}`]),
    ...(window.location.protocol === 'https:' ? ['Secure'] : []),
  ].join('; ')

  return getCookie(name) === value
}

export {
  getCookie,
  cookieStrToObj,
  trySetCookie,
}
